import {Modal} from 'bootstrap'

class ReportForm {
    constructor(form) {
        this.form = form
        this.description = ''
        this.entry_id = false
        this.fields = [ 'description', 'file', 'entry_id' ]
        this.action = 'mats_add_report'
        this.file = false
        this.modalController = false
        this.preloader = $('<span class="spinner-grow" style="margin-top: 6px;"></span>')
        this.submitText = ''
        this.init()
    }

    init() {
        this.events()
        this.elements()
        this.initModal()
    }

    elements() {
        this.$modal = this.form.find('.mats-member-report__modal')
        this.$submit = this.form.find('[type="submit"]')
        this.submitText = this.$submit.html()
    }

    initModal() {
        this.$modal = this.$modal.appendTo('body')
        this.modalController = new Modal(this.$modal[ 0 ])
        this.$message = this.$modal.find('.message')
        this.hideMessage()
        window.rf = this
    }

    hideMessage() {
        this.modalController.hide()
    }

    showMessage(message, success = true) {
        let type = success ? 'success' : 'error'
        this.$message.html(message).attr('class', `message alert  alert-${type}`)
        this.modalController.show()
    }

    showPreloader() {
        this.$submit.html(this.preloader)
    }

    hidePreloader() {
        this.$submit.html(this.submitText)
    }

    events() {
        this.form.submit(e => {
            this.submit(e)
        })
    }

    submit(e) {
        e.preventDefault()
        this.showPreloader()
        this.fields.forEach(fieldName => {
            let field = this.getFieldByName(fieldName)
            if ( field[ 0 ].type === 'file' ) {
                let files = field[ 0 ].files
                if ( files.length ) {
                    this[ fieldName ] = field[ 0 ].files[ 0 ]
                }
            }
            else {
                this[ fieldName ] = field.val()
            }
        })

        let data = new FormData()
        data.append('file', this.file)
        data.append('description', this.description)
        data.append('entry_id', this.entry_id)
        data.append('action', this.action)

        $.ajax({
            url:         ajax_url,
            data,
            processData: false,
            contentType: false,
            type:        'POST',
            success:     response => {
                this.showMessage(response.data, response.success);
                setTimeout(()=>{
                    location.pathname = '/oversikt'
                },5000);
                
            },
            complete:    () => {
                this.hidePreloader()
            }
        })
    }

    getFieldByName(name) {
        return this.form.find(`[name="${name}"]`)
    }
}


export default ReportForm
